import RelationChart from '@/lib/render';
import http from '@/lib/http';
// import {json} from "d3-fetch"

export function query(url){
		let _url = process.env.VUE_APP_PROXY+url;
		return http.get(_url);			
};
export function render(ref, data, config){
		config = config != undefined ? config : {};
		const RLC = new RelationChart(ref, data, config);
		// RLC.autozoom();
};
export function idToIdx(data){
		let nodes_map = {};
		let links = [];

		for (let i = 0; i < data.nodes.length; i++) {
			let id = data.nodes[i].id;
			nodes_map[id] = i;
		}
		for (let i = 0; i < data.links.length; i++) {
			let source = data.links[i].source;
			let target = data.links[i].target;
			data.links[i].source = nodes_map[source];
			data.links[i].target = nodes_map[target];
		}

		return data;
};